import React from "react"
import {FieldQuickFilterViewProps} from "../../../render/quick-filter-view";
import {QUICK_FILTER_ALL_VALUES} from "../../../../gd/const/quick-filter";
import UserIcon from "../../../../gd-ui/icon/user/user";


export default function FieldUser_QuickFilterView(props: FieldQuickFilterViewProps) {

    const {value} = props

    let icon = null
    let label = ''

    switch (value) {
        case QUICK_FILTER_ALL_VALUES:
            label = 'All users'
            break
        case null:
        case 'null':
            label = 'No user'
            break

        default:
            const user = gd.session.users.get(value);

            if (user) {
                icon = <UserIcon className="icon" userId={user.id} size="22"/>
                label = user.name
            } else {
                label = 'No user found'
            }
    }

    return (
        <div className="ui5-group-by-view">
            {icon}
            <div className="name">{label}</div>
        </div>
    )


}